<template>
  <div>
    <v-layout row wrap>
      <Loader></Loader>
      <v-flex xs12 md8 class="mr-6">
        <video
          autoplay
          id="myVideo"
          controls="controls"
          preload="none"
          width="900"
          height="fill-parent"
          :poster="getApiUrl+'/images/cover_images/tutorials-video-cover-img.jpg'"
        >
          <source id="mp4" :src="videoSource" type="video/mp4" />
        </video>
        <h5 :style="{color:getThemeColor}">Currently Playing: {{nowPlaying}}</h5>
      </v-flex>
      <v-flex xs12 md3 class="ml-15">
        <v-virtual-scroll :items="videos" height="800" item-height="180">
          <template v-slot:default="props">
            <v-list-item :key="props.item.id">
              <v-list-item-content>
                <v-img
                  @click="playVideo(props.item)"
                  :src="getApiUrl+'/images/cover_images/tutorials-video-cover-img.jpg'"
                ></v-img>
                <v-list-item-title @click="playVideo(props.item)" class="my-8">{{ props.item }}</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action></v-list-item-action>
            </v-list-item>
            <v-divider></v-divider>
          </template>
        </v-virtual-scroll>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";

export default {
  props: ["videos", "vidPath", "imgPath"],
  components: { Loader },
  mounted() {
    this.playOnMount();
  },
  watch: {
    videos(newVal, oldVal) {
      this.playOnMount();
    }
  },
  data: () => ({
    videoSource: null,
    nowPlaying: "No Video Selected Yet, Click on Any Video on The Right"
  }),
  computed: {
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
    getApiUrl() {
      return this.$store.getters.getApiUrl;
    }
  },
  methods: {
    playVideo(video) {
      this.nowPlaying = video;
      this.videoSource = this.getApiUrl + this.vidPath + video;
      const videoEl = document.getElementById("myVideo");
      videoEl.src = this.videoSource;
      videoEl.play();
    },
    playOnMount() {
      if (this.videos.length > 0) {
        this.nowPlaying = this.videos[0];
        this.videoSource = this.getApiUrl + this.vidPath + this.videos[0];
        const videoEl = document.getElementById("myVideo");
        videoEl.src = this.videoSource;
        videoEl.play();
      }
    }
  }
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css?family=Raleway:400,400i,700,700i&display=swap");
</style>